import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import classNames from 'classnames';
import { add, isBefore, isAfter, format, formatDistanceToNow } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';
import { Link } from 'react-router-dom';

import './Race.scss';
import customLocale from '../../../configs/date-fns';

class Race extends PureComponent {
  constructor(props) {
    super(props);

    this.selectedRef = React.createRef();
    this.state = {
      hourTime: false,
      blink: false,
      highLightIntervalId: 0,
      hourTimeIntervalId: 0,
      blinkId: 0
    };
  }

  componentDidMount() {
    const date = utcToZonedTime(this.props.racingEvent.eventStart * 1000, this.props.selectedTimezone);
    if (isBefore(date, add(new Date(), { hours: 1 })) && isAfter(date, new Date()) && this.props.valid) {
      const hourTimeInterval = setInterval(() => {
        this.setState({ hourTime: !this.state.hourTime });
      }, 2000);

      const blinkInterval = setInterval(() => {
        this.setState({ blink: !this.state.blink });
      }, 2000);

      this.setState({
        hourTimeIntervalId: hourTimeInterval,
        blinkId: blinkInterval
      });
    }
  }

  componentDidUpdate() {
    if (this.props.selected && this.selectedRef){
      const ref = this.selectedRef.current;
      ref.scrollIntoView({ behavior: 'smooth' });
    }
  }

  componentWillUnmount() {
    if (this.state.hourTimeIntervalId !== 0) {
      clearInterval(this.state.hourTimeIntervalId);
      clearInterval(this.state.blinkId);
    }
  }

  getStatus = (status) => {
    if (status){
      switch (status) {
        case 1:
          return ('OPEN');
        case 2:
        case 4:
        case 6:
          return ('RUNNING');
        case 7:
          return ('SUSPENDED');
        default:
          return ('OFFICIAL');
      }
    }
    return this.props.racingEvent.status;
  }

  render() {
    const { t, racingEvent, selectedTimezone, setRef, selected, meetingCode } = this.props;
    const eventStart = racingEvent.eventStart * 1000;
    const date = utcToZonedTime(eventStart, selectedTimezone);
    const dateIsAfterNow = isAfter(eventStart, new Date());

    let time = format(date, 'HH:mm');

    if (this.getStatus(racingEvent.statusCode) === 'OFFICIAL') {
      time = t('horseDetail.closed');
    } else if ((isBefore(eventStart, add(new Date(), { hours: 1 })) && isAfter(eventStart, add(new Date(), { minutes: 2 })))) {
      time = `${ t('horseDetail.in') } ${ formatDistanceToNow(eventStart, { locale: customLocale }) }`;
    } else if (isBefore(eventStart, add(new Date(), { minutes: 2 }))) {
      time = t('horseDetail.starting');
    } else if (this.getStatus(racingEvent.statusCode) === 'SUSPENDED'){
      time = t('horseDetail.suspended');
    }

    return (
      <>
        {
          meetingCode !== undefined &&
          <Link
            ref={ setRef }
            to={ `/racing/${ meetingCode }/${ racingEvent.eventCode || racingEvent.code }${ location.search }` }
            className={
              classNames({
                'race__container': true,
                'race__hide': this.getStatus(racingEvent.statusCode) === 'OPEN'
                  && isBefore(eventStart, add(new Date(), { seconds: 120 })) && dateIsAfterNow && this.state.blink,
                'race__show': this.getStatus(racingEvent.statusCode) === 'OPEN'
                  && isBefore(eventStart, add(new Date(), { seconds: 120 })) && dateIsAfterNow && !this.state.blink,
                'race__container--selected': selected
              })
            }
          >
            <div
              ref={ this.selectedRef }
              className={
                classNames({
                  'race__race-sort': true,
                  'race__race-sort--open': this.getStatus(racingEvent.statusCode) === 'OPEN' && dateIsAfterNow,
                  'race__race-sort--resulted': (
                    racingEvent.result ||
                    this.getStatus(racingEvent.statusCode) === 'PRELIMINARY' ||
                    this.getStatus(racingEvent.statusCode) === 'OFFICIAL' ||
                    this.getStatus(racingEvent.statusCode) === 'SUSPENDED'
                  ),
                  'race__race-sort--started': (
                    (this.getStatus(racingEvent.statusCode) === 'OPEN' && isBefore(eventStart, add(new Date(), { seconds: 120 }))) ||
                    (this.getStatus(racingEvent.statusCode) === 'OPEN' && isBefore(eventStart, new Date())) ||
                    this.getStatus(racingEvent.statusCode) === 'RUNNING' ||
                    racingEvent.status === 'CLOSED'
                  ),
                  'race__race-sort--cancelled': (
                    this.getStatus(racingEvent.statusCode) === 'CANCELLED' ||
                    this.getStatus(racingEvent.statusCode) === 'DEACTIVATED'
                  )
                })
              }
            >{ racingEvent.raceNo }</div>
            <div
              className={
                classNames({
                  'race__race-date': true,
                  'race__race-date--text': racingEvent?.resultText?.length > 8
                })
              }
            >
              {
                !racingEvent.resultText ?
                  time
                  :
                  <>
                    <span>{ racingEvent.resultText }</span>
                  </>
              }
            </div>
          </Link>
        }
      </>
    );
  }
}

Race.propTypes = {
  t: PropTypes.func,
  location: PropTypes.object,
  setRef: PropTypes.func,
  selectedTimezone: PropTypes.string,
  racingEvent: PropTypes.object,
  index: PropTypes.number,
  valid: PropTypes.bool,
  selected: PropTypes.bool,
  meetingCode: PropTypes.number
};

const mapState = state => ({
  selectedTimezone: state.odds.selectedTimezone
});

export default connect(mapState, null)(withTranslation('common')(Race));
